import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppRoutes } from 'src/app/core/models/routes.model';
import { BaseComponent } from 'src/app/core/components/base-component/base-component.component';
import {
  REGISTER_FORM_FIELDS_CONFIG,
  REGISTER_FORM_INITIAL_MODEL,
  RegisterFormFieldConfig,
  RegisterFormModel,
} from './config/form.config';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent extends BaseComponent {
  readonly AppRoutes = AppRoutes;
  fieldsConfig: RegisterFormFieldConfig[] = REGISTER_FORM_FIELDS_CONFIG;
  registerFormModel: RegisterFormModel = { ...REGISTER_FORM_INITIAL_MODEL };

  onSubmit(form: NgForm): void {
    if (form.invalid || this.registerFormModel.password !== this.registerFormModel.confirmPassword) {
      form.control.markAllAsTouched();
      return;
    }

    const payload: RegisterFormModel = { ...this.registerFormModel };
    console.log('[register-form] payload', payload);
    this.toast.add({
      severity: 'success',
      summary: 'Registrazione completata',
      detail: 'La registrazione e stata inviata correttamente.',
    });
    this.registerFormModel = { ...REGISTER_FORM_INITIAL_MODEL };
    form.resetForm(this.registerFormModel);
    this.router.navigate([AppRoutes.AUTH, AppRoutes.AUTH_LOGIN]);
  }

  get passwordsDoNotMatch(): boolean {
    return (
      this.registerFormModel.password.length > 0 &&
      this.registerFormModel.confirmPassword.length > 0 &&
      this.registerFormModel.password !== this.registerFormModel.confirmPassword
    );
  }
}
